<div class="main-container" [dir]="documentDir" [attr.data-testid]="vm.slug">
  <div class="usp-container flex-column d-none d-md-flex">
    <div class="usp-title-row">
      <span class="title row-usp" *ngFor="let usp of vm.sellingPoints" [innerHTML]="usp.title | lineBreak"></span>
    </div>
    <div class="usp-divider-row">
      <div class="divider" *ngFor="let usp of vm.sellingPoints"></div>
    </div>
    <div class="usp-description-row">
      <span
        class="description row-usp"
        *ngFor="let usp of vm.sellingPoints"
        [innerHTML]="usp.description | replacePriceAndCurrency: vm.subscriptionPrice:vm.currency | lineBreak"
      ></span>
    </div>
  </div>

  <swiper
    [dir]="documentDir"
    *osnRerenderOnDirectionChange
    [slidesPerView]="1"
    [spaceBetween]="0"
    [index]="lastActiveSwiperIndex"
    (paginationUpdate)="swiperPaginationChange($any($event))"
    [pagination]="{
      clickable: true
    }"
    class="usp-swiper d-md-none"
  >
    <ng-template swiperSlide *ngFor="let usp of vm.sellingPoints">
      <div class="usp-container">
        <div class="usp">
          <span class="title" [innerHTML]="usp.title | lineBreak"></span>
          <div class="divider"></div>
          <span
            class="description"
            [innerHTML]="usp.description | replacePriceAndCurrency: vm.subscriptionPrice:vm.currency | lineBreak"
          ></span>
        </div>
      </div>
    </ng-template>
  </swiper>
</div>
